import React from 'react';
import {  Github, Linkedin, Mail, MapPin } from 'lucide-react';
import photo from "../images/me.jpeg";
import Medium from "../images/medium.svg";
const Hero = ({ data }) => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          
   
          <div className="hero-container-second">
                  <img  class="hero-image" 
          src={photo} 
          alt="Ismail Essagar" 
          className="hero-image"
        />
          
          <div className="hero-subtitle">
            <p className="text-big speech-bubble">
              Data Science and Engineering turn raw data into informed decisions, 
              revealing hidden truths and opening paths where curiosity becomes power.
            </p>
          </div>
          </div>

          <div className="hero-details">
            <div className="hero-info">
                <div className="hero-label">
    <span className="label">DATA ENGINEER &  SCIENTIST</span>
  </div>
              <div className="info-item">
                <MapPin size={16} />
                <span className="text-body">{data.location}</span>
              </div>
              <div className="info-item">
                <span className="label-small">{data.experience}</span>
              </div>
            </div>

            <div className="hero-links">
              <a href={`mailto:${data.email}`} className="hero-link">
                <Mail size={20} />
              </a>
              <a href={`https://${data.linkedin}`} target="_blank" rel="noopener noreferrer" className="hero-link">
                <Linkedin size={20} />
              </a>
              <a href={`https://${data.github}`} target="_blank" rel="noopener noreferrer" className="hero-link">
                <Github size={20} />
              </a>
              <a href="https://medium.com/@essagarismail" target="_blank" rel="noopener noreferrer" className="hero-link">
  <img src={Medium} alt="Medium" style={{ width: 20, height: 20 }} />
</a>
            </div>
          </div>

          <div className="hero-actions">
            <button className="btn-accent" onClick={() => scrollToSection('experience')}>
              Explore My Work
            </button>
            <button  onClick={() => scrollToSection('contact')} className="btn-primary">
              Get In Touch
            </button>
          </div>
        </div>

        <div className="hero-scroll">

        </div>
      </div>
    </section>
  );
};

export default Hero;